// extracted by mini-css-extract-plugin
export default {"cls1":"Comment-cls1__ce5130a86cc05f081edb","cls2":"Comment-cls2__a1b11e0edb23e09d7567 Comment-cls1__ce5130a86cc05f081edb"};